import React from 'react'
import Spinner from './Spinner'

const PaymentSpinner = () => <Spinner loadingText={'Payment Processing...'} />

export default PaymentSpinner